import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import Grid from '@material-ui/core/Grid';
import { CURSOR} from '../../../../styles/fonts/MCFontConstants';
export const AddSetContainer = styled(Grid)``;
export const AddSetScan = styled(Grid)`
    & .AddSetTabs Button {
        min-width: fit-content;
        min-height: 30px;
        font-size: 14px;
        font-family: 'AvenirNextWorld Regular';
        text-transform: capitalize;
        font-weight: 500;
        padding: 0;
        color: #202124;
        opacity: 1;
        letter-spacing: 0;
    }

    & .AddSetTabs {
        min-height: 30px;
    }

    & .AddSetTabs Button span {
        flex-direction: row;
        justify-content: left;
    }

    & .AddSetTabs .MuiTabs-indicator {
        background-color: #1021eb;
    }

    & .AddSetTabs Button.ExternalScannerTab {
        margin-left: 15px;
    }

    & .AddSetTabs Button.Mui-selected {
        font-family: 'AvenirNextWorld Demi';
    }
`;

export const TabContainer = styled.div`
    padding: 10px 0 0 0;
`;

export const AddSetManually = styled(Grid)``;

export const AddSetBatch = styled.div`
    margin: 10px 0 2px 0;
`;

export const DetailsMainContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`;

export const MainContainerItems = styled.div`
    width: ${({ isAddSetManually }) => (isAddSetManually ? '100%' : '47%')};
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin-bottom: ${({ setMarginBottom }) =>
        setMarginBottom ? '16px' : '0px'};

    ${media.mobileDevice`
        width: 100%;
    `}

    & .set-item-search-box {
        border: 2px solid #ebeded;
        border-radius: 6px;
        background: ${({ backgroundDisabled }) =>
            backgroundDisabled
                ? '#F1F1F1'
                : '#ffffff 0% 0% no-repeat padding-box'};
        height: 40px;
        width: ${({ width }) => (width ? width : '90%')};
        /* padding: 0 10px; */
        ::placeholder {
            opacity: ${({ disabled }) => (disabled ? 0.8 : 0.5)};
        }
        &:focus-visible {
            outline: white;
        }
        ${media.mobileDevice`
            width: 100%;
        `};
    }

    & .set-item-search-box .inputSearch {
        padding: 0 10px;
    }

    & .set-item-search-box input {
        padding: 8px 0 10px 0 !important;
        font-family: 'AvenirNextWorld Regular' !important;
        font-size: ${({ fontSize }) =>
            fontSize ? fontSize : '16px !important'};
    }
`;

export const Title = styled.div`
    font-family: AvenirNextWorld demi;
    color: #202124;
    font-size: 14px;
    margin-bottom: 8px;

    &:after {
        content: '${(props) => (props.showAstrisk ? '*' : '')}';
        color: red;
        padding-left: 3px;
    }
`;

export const TextAreaContainer = styled.div`
    margin: 0px;
    ${media.mobileDevice`
     margin: 0px;
    `}
`;

export const TextArea = styled.textarea`
    resize: none;
    width: 100%;
    height: ${({ height }) => (height ? height : '330px')};
    margin-top: 0px;
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 2px solid #ebeded;
    border-radius: 6px;
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: -0.11px;
    font-size: 14px;
    padding: 10px 0 0 10px;
    &::-webkit-input-placeholder {
    }
    &:focus {
        outline: none !important;
    }
    ${media.mobileDevice`
     height: 182px;
    `}
`;

export const ButtonContainer = styled.div`
    width: 100%;
`;

export const TextBold = styled.div`
    text-align: left;
    font-family: AvenirNextWorld Demi;
    font-size: 15px;
    letter-spacing: -0.12px;
    align-self: center;
    padding: ${(props) => props.isScan && '0 0 0 10px'};
`;

export const HeaderGridContainer = styled(Grid)`
    padding: 10px 15px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 2px #00000029;
    border: 1px solid #dcdcdc;
    border-radius: 6px 6px 0px 0px;
    margin-top: 10px;
`;

export const HeaderTextContainer = styled(Grid)`
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    color: #3c3c3c;
`;

export const GridContainer = styled(Grid)`
    padding: 10px 15px;
    background: #ffffff 0% 0% no-repeat padding-box;
    border-left: 1px solid #dcdcdc;
    border-right: 1px solid #dcdcdc;
    &:nth-child(odd) {
        background: #f3f3f3 0% 0% no-repeat padding-box;
    }
    &:last-child {
        border-bottom: 1px solid #dcdcdc;
    }
`;

export const ItemCardTextContainer = styled(Grid)``;

export const DeleteBtnDiv = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const SetsHeader = styled.div`
    font-size: 20px;
    margin-top: 10px;
    font-family: 'AvenirNextWorld Demi';
    color: #140f4b;
    ${media.mobileDevice`
    font-size: 18px;
    `}
`;

export const DesktopSetsDiv = styled.div`
    ${media.mobileDevice`
        display: none;
    `}
`;

export const MobileSetsDiv = styled.div`
    display: none;
    ${media.mobileDevice`
        display: block;
    `}
`;
export const BatchNumDiv = styled.div`
    width: 100%;
    font-size: 14px;
    font-family: 'AvenirNextWorld Demi';
    letter-spacing: -0.1px;
    color: #140f4b;
    margin-top: -3px;
`;

export const BatchNum = styled.span`
    width: 100%;
    font-family: 'AvenirNextWorld Regular';
    font-size: 14px;
`;

export const SetDesc = styled.div`
    width: 100%;
    font-size: 13px;
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: -0.1px;
    color: #140f4b;
    opacity: 0.7;
`;

export const CurrentLoc = styled.div`
    width: 100%;
    font-size: 13px;
    font-family: 'AvenirNextWorld Demi';
    color: #140f4b;
    margin-top: 12px;
    letter-spacing: -0.1px;
`;

export const AccountName = styled.div`
    width: 100%;
    font-size: 14px;
    font-family: 'AvenirNextWorld Regular';
    color: #140f4b;
    letter-spacing: -0.11px;
    ${media.mobileDevice`
        font-size: 13px;
    `}
`;

export const SetNum = styled.div`
    width: 100%;
    font-size: 15px;
    font-family: 'AvenirNextWorld Demi';
    color: #140f4b;
    display: ${({ display }) => (display ? display : '')};
    align-items: ${({ alignItems }) => (alignItems ? alignItems : '')};
`;

export const BarCode = styled.div`
    font-size: 13px;
    font-family: 'AvenirNextWorld Regular';
    color: #140f4b;
`;

export const SelectedCurrentLocation = styled.div`
    width: 360px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: ${({ whiteSpace }) => (whiteSpace ? whiteSpace : 'nowrap')};
    ${media.mediumDevice`
       width: 300px;
    `}
    ${media.smalDevice`
       width: 240px;
    `}
    ${media.mobileDevice`
       width: 240px;
    `}
    ${media.exSmallDevice`
       width: 210px;
    `}
`;
export const Subtitle = styled.div`
    font-size: 16px;
    font-family: AvenirNextWorld Regular;
`;
// scan barcode css

export const Container = styled.div`
    padding: 10px 15px 15px 15px;
    & .scandit-barcode-picker video {
        visibility: visible !important;
    }
`;
export const Header = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: -20px;
    ${media.mediumDevice`
        margin-bottom: 10px;
    `}
    ${media.mobileDevice`
    margin-top:0px;
    `}
`;
export const Icon = styled.img.attrs((props) => ({
    src: props.path,
}))`
    width: 22px;
    height: 23px;
    cursor: ${CURSOR};
`;
export const HeaderTitle = styled.label`
    font-family: AvenirNextWorld Demi;
    color: #202124;
    font-size: 18px;
    margin-bottom: 12px;
    ${media.mobileDevice`
    margin-bottom:0px;
    `}
`;

export const Content = styled.div`
    & .videobox {
        position: relative;
    }
`;

export const ActionButton = styled.div`
    min-height: 60px;
    display: flex;
    position: absolute;
    width: 100%;
    bottom: 0;
    margin: 0;
    right: 0;
    padding: 11px 20px !important;
    background-color: #ffffff;
    justify-content: center;
    box-shadow: 0px -3px 6px #00000014;
    ${media.mobileDevice`
        position: fixed;
        background-color: #f5f5f5;
        box-shadow: none;
    `}
`;

export const CreditCardMessageDiv = styled.div`
    margin: 10px 5px 10px 0;
`;
export const CreditCardMessageRedText = styled.div`
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '13px')};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Regular'};
    color: red;
    margin: ${({ margin }) => (margin ? margin : '0')};
    ${media.mobileDevice`
        font-size: ${({ mbFontSize }) => (mbFontSize ? mbFontSize : '13px')};
    `}
`;
export const OptionContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin: 0;
    padding: 0;
    cursor: auto;
    padding: ${({ padding }) => (padding ? padding : '5px 10px')};
    & .template {
        font-size: 14px;
        color: #140f4b;
        font-family: AvenirNextWorld Regular;
    }
`;
export const AccountFieldTitle = styled.label`
    color: #140f4b;
    font-size: 14px;
    //HCP id slanting
    //font-family: AvenirNextWorld Regular;
    font-family: ${(props) =>
        props.fontFamily ? props.fontFamily : 'AvenirNextWorld Regular'};
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: ${(props) => (props.width ? props.width : 'auto')};
    margin: ${(props) => (props.margin ? props.margin : '0px')};
    cursor: pointer;
    ${media.mediumDevice`
         max-width: ${(props) => (props.iPadwidth ? props.iPadwidth : '25vw')};
    `}
    ${media.mobileDevice`
        max-width: ${(props) =>
            props.mobileWidth ? props.mobileWidth : 'auto'};
    `}
`;

export const AccountFieldAddress = styled.label`
    color: #140f4b;
    opacity: 0.7;
    font-size: 12px;
    font-family: AvenirNextWorld Regular;
    display: inline-block;
    /* margin-right: 10px; */
    max-width: ${(props) => (props.width ? props.width : 'auto')};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    margin: ${(props) => (props.margin ? props.margin : '0px')};
    ${media.mediumDevice`
         max-width: ${(props) => (props.iPadwidth ? props.iPadwidth : '25vw')};
    `}
    ${media.mobileDevice`
        max-width: ${(props) =>
            props.mobileWidth ? props.mobileWidth : 'auto'};
    `}
`;
export const OptionalLoadMoreView = styled.div`
    background-color: #f5f5f5;
    height: ${({ height }) => (height ? height : '200px')};
    display: flex;
    justify-content: center;
    align-items: center;
    // some space is left after grey message area
    margin: ${({ margin }) => (margin ? margin : '10px 0 0 0')};
    flex-direction: column;
    width: 100%;
    & p {
        color: #4f4f4f;
        font-size: 18px;
        font-family: AvenirNextWorld Regular;
        text-align: center;
        margin: 0 0 10px;
    }
    & button {
        padding: 10px;
        color: #1010eb;
        border: 1px solid #1010eb;
        border-radius: 20px;
        text-align: center;
        padding: 5px 13px;
        font-family: AvenirNextWorld Demi;
        font-size: 15px;
        background: #f5f5f5;
    }
`;
export const OuterContainer = styled.div`
    display: ${(props) => (props.display ? props.display : 'flex')};
    flex-direction: ${(props) => (props.isLoadMore ? 'column' : 'row')};
    margin: 0;
    padding-left: 0;
    width: 100%;
    position: relative;
    margin: ${(props) => (props.margin ? props.margin : '0')};
`;
export const ImgDiv = styled.div`
    width: 24px;
    align-items: flex-start;
    display: flex;
    justify-content: center;
`;
export const LineSeparator = styled.hr`
    border: 0;
    border-top: 2px solid #e8e8e8;
    box-sizing: content-box;
    height: 0;
    overflow: visible;
    margin: 0px 8px -1px 8px;
`;

export const MessageContainer = styled.div`
    text-align: center;
    position: absolute;
    bottom: 0px;
    width: 100%;
    left: 0;
    right: 0;
    padding: 10px 10px;
    background: ${(props) =>
        props.RedBg
            ? '#ED002A 0% 0% no-repeat padding-box'
            : '#525252 0% 0% no-repeat padding-box'};
    border-radius: 0px 0px 10px 10px;
    opacity: 0.8;
`;

export const Msg = styled.div`
    font-family: ${(props) =>
        props.isRegular ? 'AvenirNextWorld Regular' : 'AvenirNextWorld Demi'};
    font-size: 12px;
    color: #ffffff;
    text-shadow: 0px 3px 6px #00000029;
`;

export const CameraScan = styled.div`
    & .scandit-container {
        border-radius: 6px;
        height: calc(100vh - 300px) !important;

        ${media.largeDevice`
            height: calc(100vh - 380px) !important;
       `}

        @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {
            height: calc(100vh - 300px) !important;
        }

        ${media.mediumDevice`
            height: calc(100vh - 400px) !important;
        `}

        @media screen and (min-device-width: 825px) and (max-device-width: 840px) and (min-device-height: 1100px) and (max-device-height: 1120px) and (orientation: portrait) {
            height: calc(100vh - 380px) !important;
        }

        @media screen and (min-device-width: 768px) and (max-device-width: 1000px) {
            height: calc(100vh - 360px) !important;
        }

        ${media.smalDevice`
            height: calc(100vh - 350px) !important;
        `}
        ${media.mobileDevice`
            height: calc(100vh - 300px) !important;
        `}
        @media screen and (max-device-width: 390px) {
            height: calc(100vh - 280px) !important;
        }
        @media screen and (max-device-width: 375px) {
            height: calc(100vh - 240px) !important;
        }
        @media screen and (max-device-width: 360px) {
            height: calc(100vh - 280px) !important;
        }
        @media screen and (min-device-width: 600px) and (max-device-width: 1000px) and (orientation: landscape) {
            height: calc(100vh - 135px) !important;
        }
    }
    .scandit {
        .scandit-laser {
            ${media.mediumDevice`

                left: 12.5% !important;

                width: 75% !important;

            `}

            @media screen and (min-device-width: 1360px) and (max-device-width: 1370px) and (min-device-height: 1020px) and (max-device-height: 1130px) and (orientation: landscape) {
                left: 12.5% !important;

                width: 75% !important;
            }

            @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {
                left: 12.5% !important;

                width: 75% !important;
            }

            @media screen and (min-device-width: 1070px) and (max-device-width: 1090px) and (min-device-height: 800px) and (max-device-height: 820px) and (orientation: landscape) {
                left: 12.5% !important;

                width: 75% !important;
            }

            ${media.smalDevice`

                left: 12.5% !important;

                width: 75% !important;

            `}

            ${media.mobileDevice`

                left: 12.5% !important;

                width: 75% !important;

            `}
        }
    }

    & .scandit-barcode-picker .scandit-logo {
        display: none;
    }
    & .scandit-barcode-picker .scandit-camera-switcher {
        display: none !important;
    }

    & .scandit-barcode-picker .scandit-viewfinder {
        border: 5px solid white;
        border-radius: 12px;
    }
    // & .scandit-barcode-picker video {
    //     object-fit: cover !important;
    //     border-radius: 12px;
    // }
    & .scandit-laser {
        /* width: 312px !important;
        height: 140px !important;
        left: 50% !important;
        top: 100px !important;
        transform: translate(-50%, -50%) !important;
        margin: 75px auto auto auto; */
        border: 5px solid white;
        border-radius: 12px;
        /* ${media.smalDevice`
            margin: 145px auto auto auto;
            top: 135px !important
        `}
        ${media.mobileDevice`
            width: auto;
            margin: 30px auto 0 auto;
            top: 185px !important;
        `}
        @media screen and (max-device-width: 375px){
            top: 110px !important;
            height: 90px !important;
        }
        @media screen and (max-device-width: 360px){
            top: 175px !important;
            height: 185px !important;
        } */
    }

    & .scandit-laser:after {
        background: url(${(props) => props.ScanditLogo});
        content: '';
        position: absolute;
        /* top: 120px; */
        top: 95%;
        right: 0;
        width: 50px;
        height: 50px;
        @media screen and (max-device-width: 375px) {
            top: 75px;
        }
        @media screen and (max-device-width: 360px) {
            top: 122px;
        }
    }

    & .scandit-barcode-picker {
        max-width: 100% !important;
        max-height: 100% !important;
        background-color: unset !important;
    }
`;

export const TroubleContainer = styled.div`
    color: #ffffff;
    font-family: 'AvenirNextWorld Demi';
    font-size: 16px;
    text-shadow: 0px 3px 6px #00000029;
    & .avoid-glare-text {
        font-family: 'AvenirNextWorld Regular';
        width: 250px;
        margin: auto;
        ${media.mobileDevice`
         width: auto;              
        `}
    }
`;

export const ShowMsg = styled.div``;

export const ManualEntryDiv = styled.div`
    width: 430px;
    display: flex;
    flex-direction: column;
    ${media.mobileDevice`
         width:310px;              
    `}
`;

export const Text = styled.div`
    font-size: 16px;
    font-family: 'AvenirNextWorld Regular';
    color: #000000;
    padding-bottom: 6px;
    padding-left: ${({ paddingLeft }) => (paddingLeft ? paddingLeft : '')};
    ${media.mobileDevice` 
        font-family:'AvenirNextWorld Regular';
        padding-bottom: 10px;
        line-height: ${({ lineHeight }) => (lineHeight ? lineHeight : '')};
    `};
`;

export const StyledDiv = styled.div`
    width: 100%;
    height: 25px;
    margin: 0 0 0 0px;
    ${media.mobileDevice`
    display:none;
`}
`;

export const ManualButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const ManualSetsDiv = styled.div`
    background: ${(props) =>
        !props.isChecked && '#fff5e4 0% 0% no-repeat padding-box'};
    box-shadow: ${(props) => !props.isChecked && '0px 0px 6px #00000029'};
    border-radius: ${(props) => !props.isChecked && '6px'};
    padding: 0 10px;
    margin: 10px 0 20px 0;
`;

export const ConfirmationDiv = styled.span`
    display: flex;
    padding-top: 10px;
`;

export const SetNumbers = styled.div`
    padding: 0 0 0 30px;
`;

export const SuccessMsg = styled.div`
    font-size: 14px;
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: -0.11px;
    color: #14853d;
    ${media.mobileDevice` 
       margin: ${({ mbMargin }) => mbMargin && mbMargin};
    `};
`;

export const ErrorMessage = styled.div`
    font-size: 14px;
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: -0.11px;
    color: #ff0000;
    ${media.mobileDevice` 
       margin: ${({ mbMargin }) => mbMargin && mbMargin};
    `};
`;

export const SetAddedSuccessDiv = styled.div`
    font-family: 'AvenirNextWorld Demi';
    font-size: 16px;
    color: #ffffff;
    text-align: center;
    padding: 10px 0;
    position: absolute;
    top: 0;
    z-index: 1;
    width: 100%;
    &.shape-qr-found {
        background: #140f4b 0% 0% no-repeat padding-box;
        border-radius: 10px 10px 0px 0px;
        opacity: 0.8;
    }
    &.additional-set {
        background: #525252 0% 0% no-repeat padding-box;
        border-radius: 10px 10px 0px 0px;
        opacity: 0.8;
        padding: 20px 0;
    }
`;

export const SpinnerDiv = styled.div`
    width: 60px;
    height: 60px;
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #707070;
    border-radius: 38px;
    opacity: 0.57;
    margin: 0 auto;
    padding-top: 8px;
`;
